import * as React from 'react';

import {styled} from '@mui/material/styles';
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';


export const ZmTooltip = styled(({className, ...props}) => (
  <Tooltip {...props} classes={{popper: className}} />
))(({theme}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: '0px 4px 8px rgba(19, 22, 25, 0.1), 0px 2px 4px rgba(19, 22, 25, 0.1)',
    border: `1px solid ${theme.palette.common.swatch['30']}`,
    fontWeight: 450,
    fontSize: '.875rem',
    lineHeight: '1.25rem',
    borderRadius: '8px',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
  [`& .${tooltipClasses.arrow}::before`]: {
    border: `1px solid ${theme.palette.common.swatch['30']}`,
    borderRadius: '2px',
  },
}));
